import { Component, Input, OnInit } from '@angular/core';
import { Waste } from 'src/app/performance-dashboard/model/performance.model';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-waste-consumption',
  templateUrl: './waste-consumption.component.html',
  styleUrls: ['./waste-consumption.component.css']
})
export class WasteConsumptionComponent implements OnInit {
  @Input() wasteData;
  clonedWasteData: { [s: string]: Waste } = {};
  DisableExport : boolean = false;

  constructor() { }

  ngOnInit(): void {
  }


  onRowEditInit(waste: Waste) {
    this.clonedWasteData[waste.Id] = { ...waste };
    this.DisableExport = true;
  }

  onRowEditSave(waste: Waste, index: number) {
    if (waste) {
      delete this.clonedWasteData[waste.Id];

      let newWasteData = [];
      this.wasteData.forEach(element => {
        if(element.category !== "Total")
        newWasteData.push(element);
      });


      this.wasteData[this.wasteData.length - 1].HazardousWasteOily = newWasteData.reduce((acc, cur) => acc + cur.HazardousWasteOily, 0);
      this.wasteData[this.wasteData.length - 1].HazardousWasteChemical = newWasteData.reduce((acc, cur) => acc + cur.HazardousWasteChemical, 0);
      this.wasteData[this.wasteData.length - 1].HazardousWasteDrilling = newWasteData.reduce((acc, cur) => acc + cur.HazardousWasteDrilling, 0);
      this.wasteData[this.wasteData.length - 1].HazardousWasteOther = newWasteData.reduce((acc, cur) => acc + cur.HazardousWasteOther, 0);
      this.wasteData[this.wasteData.length - 1].NonHazardScrap = newWasteData.reduce((acc, cur) => acc + cur.NonHazardScrap, 0);
      this.wasteData[this.wasteData.length - 1].NonHazardWood = newWasteData.reduce((acc, cur) => acc + cur.NonHazardWood, 0);
      this.wasteData[this.wasteData.length - 1].NonHazardPlastic = newWasteData.reduce((acc, cur) => acc + cur.NonHazardPlastic, 0);
      this.wasteData[this.wasteData.length - 1].NonHazardDomestic = newWasteData.reduce((acc, cur) => acc + cur.NonHazardDomestic, 0);
      this.wasteData[this.wasteData.length - 1].NonHazardKitchen = newWasteData.reduce((acc, cur) => acc + cur.NonHazardKitchen, 0);
      this.wasteData[this.wasteData.length - 1].SewageWater = newWasteData.reduce((acc, cur) => acc + cur.SewageWater, 0);
      this.wasteData[this.wasteData.length - 1].OBMDisp = newWasteData.reduce((acc, cur) => acc + cur.OBMDisp, 0);
      this.wasteData[this.wasteData.length - 1].NumOfConsignmentNote = newWasteData.reduce((acc, cur) => acc + cur.NumOfConsignmentNote, 0);
    }
    this.DisableExport = Object.keys(this.clonedWasteData).length > 0 ? true : false;
  }

  onRowEditCancel(waste: Waste, index: number) {
    this.wasteData[index] = this.clonedWasteData[waste.Id];
    delete this.clonedWasteData[waste.Id];
    this.DisableExport = Object.keys(this.clonedWasteData).length > 0 ? true : false;
  }
  //  BOC Pritesh
   exportToExcel()
   {
 
   let element = document.getElementById('WasteConsumptionTableToExport');
   const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
  
   ws['!ref'] = ws['!ref'].replace('O','N');//to remove Actions Column
   /* generate workbook and add the worksheet */
   const wb: XLSX.WorkBook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
   /* save to file */  
   XLSX.writeFile(wb, "WasteConsumption.xlsx");
 
   }
   //EOC Pritesh
}



// import { Component, Input, OnInit } from '@angular/core';
// import { Waste } from 'src/app/performance-dashboard/model/performance.model';
// import { PerformanceService } from '../../../services/performance.service';
// import { ConstantsService } from '../../../../shared/services/constants.service';
// import { Router } from '@angular/router';
// import * as XLSX from 'xlsx';

// @Component({
//   selector: 'ara-waste-consumption',
//   templateUrl: './waste-consumption.component.html',
//   styleUrls: ['./waste-consumption.component.css']
// })
// export class WasteConsumptionComponent implements OnInit {
//   @Input() wasteData;
//   @Input() selectedUnit: any;
//   @Input() year: any;
//   @Input() MonthRange: any;
//   clonedWasteData: { [s: string]: Waste } = {};
//   WasteConsumptionData : any;

//   constructor(private PDService: PerformanceService,private router: Router) { }

//   ngOnInit(): void {
//   }


//   onRowEditInit(waste: Waste) {
//     this.clonedWasteData[waste.Id] = { ...waste };
//   }

//   onRowEditSave(waste: Waste, index: number) {
//     if (waste.Id > 0) {
//       delete this.clonedWasteData[waste.Id];
//       this.wasteData[index].YTD = waste.Jan + waste.Feb + waste.Mar + waste.Apr + waste.May + waste.Jun + waste.Jul + waste.Aug + waste.Sep + waste.Oct + waste.Nov + waste.Dec;
//       //this.messageService.add({severity:'success', summary: 'Success', detail:'Product is updated'});
//     } else {
//       //this.messageService.add({severity:'error', summary: 'Error', detail:'Invalid Price'});
//     }
//   }

//   onRowEditCancel(waste: Waste, index: number) {
//     this.wasteData[index] = this.clonedWasteData[waste.Id];
//     delete this.wasteData[waste.Id];
//   }

//   GetWasteConsumptionSelectedDetails(UnitId,Unit,Column){
  
//     const apiRequest = {
//       Model: {
//         "Units": this.selectedUnit,//this.child1.selectedUnit,
//         "Year": this.year,//this.child1.year,
//         "Months":this.MonthRange,//this.child1.MonthRange,
//         "ModuleName":"Waste Consumption",
//         "Component":Unit === "Total" ? 0 : UnitId,
//         "Column":Column,
//         "ComponentName":Unit
//      }
//     };

//     this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetWasteConsumptionSelectedDetails.bind(this));
//   }
//   callbackMethodForGetWasteConsumptionSelectedDetails(response){
//     if(response.Success)
//     this.WasteConsumptionData = response.Result;
//   }

//   Redirect(value,UnitId)
//   {
//  // this.router.navigate(['/pd/statistic/', value, { unitId:UnitId }])
//     window.open(ConstantsService.URL.APP + ['/pd/statistic/'+value+';unitId='+UnitId], '_self');
//   }

//    //BOC Pritesh
//    exportToExcel()
//    {
 
//    let element = document.getElementById('WasteConsumptionTableToExport');
//    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
  
//    ws['!ref'] = ws['!ref'].replace('O','N');//to remove Actions Column
//    /* generate workbook and add the worksheet */
//    const wb: XLSX.WorkBook = XLSX.utils.book_new();
//    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
//    /* save to file */  
//    XLSX.writeFile(wb, "WasteConsumption.xlsx");
 
//    }
//    //EOC Pritesh

// }
